import _ from "lodash";

export const isEmptyObj = (data) => {
  return _.isEmpty(_.pickBy(data, _.identity));
};
